import { useEffect, useState } from 'react'

import Loader from 'react-loaders'

import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const stats = [
  { value: '11+', label: 'Years Experience' },
  { value: '4', label: 'Companies' },
  { value: '15+', label: 'Technologies' },
  { value: '3', label: 'Domains Served' },
]

const About = () => {
  const aboutArray = 'About Me'.split('')

  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={aboutArray}
              idx={15}
            />
          </h1>
          <p>
            I'm a Staff Engineer with 11 years of extensive experience in
            delivering IT solutions for telecom, finance, and SEO domains. I
            have used various open-source technologies to create
            industry-grade applications and provide reliable solutions to
            various groups. My expertise includes Java, Spring Boot, Angular,
            Microservices, and AI technologies.
          </p>
          <p>
            Currently serving as Staff Engineer at Nagarro, I'm involved in
            designing and developing various modules and helping in scrum
            meetings. I'm passionate about solving real-world problems through
            innovative technology, whether it's building scalable
            microservices, implementing AI solutions, or leading technical
            teams to deliver excellence.
          </p>

          <div className="about-stats">
            {stats.map((stat) => (
              <div key={stat.label} className="stat-card">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="about-visual" aria-hidden="true">
          <div className="terminal-window">
            <div className="terminal-bar">
              <span className="dot dot-red" />
              <span className="dot dot-yellow" />
              <span className="dot dot-green" />
              <span className="terminal-title">touheed@portfolio: ~</span>
            </div>
            <div className="terminal-body">
              <p className="term-line">
                <span className="prompt">$</span> whoami
              </p>
              <p className="term-line output">
                Touheed Khan — Staff Engineer
              </p>
              <p className="term-line">
                <span className="prompt">$</span> cat expertise.txt
              </p>
              <p className="term-line output">
                Java · Spring Boot · Microservices
                <br />
                Angular · Vue · Nuxt · TypeScript
                <br />
                Spring AI · Langchain · CrewAI
              </p>
              <p className="term-line">
                <span className="prompt">$</span> grep -i "mission" career.log
              </p>
              <p className="term-line output highlight">
                "Build industry-grade solutions. Mentor. Lead with
                excellence."
              </p>
              <p className="term-line">
                <span className="prompt">$</span>
                <span className="term-cursor" />
              </p>
            </div>
          </div>
          <div className="visual-glow" />
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
